<script setup>
import NewsfeedView from './NewsfeedView.vue'

defineOptions({
  name: 'Newsfeed',
})
</script>

<template>
  <SidebarContainer
    flex
    have-menu
  >
    <template #left>
      <Sidebar />
    </template>

    <template #default="{ container }">
      <NewsfeedView :infinite-target="container" />
    </template>
  </SidebarContainer>
</template>
